import React from 'react';
import { useUser } from '@clerk/clerk-react';
import NavBarAuth from './NavBarAuth';
import NavBarPublic from './NavBarPublic';

/**
 * Smart NavBar component that renders different navigation bars
 * based on user authentication status
 */
const NavBar = () => {
  const { isLoaded, isSignedIn } = useUser();
  
  // Show a simplified version while Clerk loads your session
  if (!isLoaded) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out py-4 px-6 md:px-8">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Just the logo during loading */}
        </div>
      </div>
    );
  }
  
  // Render different NavBar components based on authentication status
  return isSignedIn ? <NavBarAuth /> : <NavBarPublic />;
};

export default NavBar;
